<div class="vidContainer" mat-dialog-content>
  <div class="vidContainer__closeContainer" (click)="closeDialog()">
    <div class="vidContainer__close">
      <img src="assets/icons/general/close.svg" alt="close">
    </div>
  </div>

  <div class="vidContainer__player">

    <app-video-player #player
      [video]="program.exercises[currentExerciseIndex].videoUrl[translate.currentLang]"
      [captions]="program.exercises[currentExerciseIndex].captionUrl[translate.currentLang]"
      [isNextEnabled]="(program.exercises.length > currentExerciseIndex + 1)"
      [isLastVideo]="program.exercises.length == currentExerciseIndex + 1"
      [isShuffleEnabled]="program.isRandom"
      (getNewExercise)="getNewExercise()"
      (getNextExercise)="getNextExercise()"
      (videoProgress)="videoProgress($event)"
      (onVideoEnded)="videoEnded($event)">
      <div videoInfo class="videoInfo">
          <div class="videoName">{{program.exercises[currentExerciseIndex].title[translate.currentLang]}}</div>
          <div id="item-1" *ngIf="program.isRandom || isSingleVideo" (click)="openAddDialog($event)">{{ 'PLAYER.addToProgram' | translate }}</div>
        </div>
      <div lastVideoScreen> <div class="nextExButton"> {{'PLAYER.lastVideoCloseBtn' | translate}} </div></div>
      <div nextVideoScreen> <div class="nextExButton"> {{'PLAYER.nextVideoBtn' | translate}} <span clasS="circleIcon"><img src="/assets/icons/video/arrow-right.svg" alt=""></span> </div></div>
    </app-video-player>
  </div>

  <div class="vidContainer__TitleContainer">
    <div class="vidContainer__TitleContainer__title"> {{program.exercises[currentExerciseIndex].title[translate.currentLang]}}</div>
  </div>
  <div class="addFav" *ngIf="buttonClicked">
    <app-add-dialog [addExercise]="program.exercises[currentExerciseIndex]" (onSelect)="openAddDialog()"></app-add-dialog>
  </div>
  <hr>
  <div class="vidContainer__listContainer" *ngIf="!isSingleVideo">
    <div class="vidContainer__listContainer__title">
      {{'PLAYER.titleOfProgram' |translate:{title: program.title} }}
    </div>
    <div class="vidContainer__listContainer__playlist" *ngIf="!program.isRandom">
        <app-box *ngFor="let ex of program.exercises"
        [id]="ex._id"
        [boxType]="'ex'"
        [type]="'play'"
        [preview]="ex.previewUrl"
        [title]="ex.title[translate.currentLang]"
        (onSelect)="skipTo(ex)"
        [selected]="program.exercises[currentExerciseIndex] == ex"></app-box>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/videoDialog/videoDialog.component.html